var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"rightMainContainer"}},[_c('operations'),_c('div',{staticStyle:{"height":"var(--middle-space)","background":"#f4f5fa"}}),_c('fileTable',{ref:"goodslist"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }